import { z } from 'zod';
export const messageRateLimitPolicyGuard = z.object({
    sendWindow: z.number().int().positive(),
    maxSendsPerRecipient: z.number().int().positive(),
});
/**
 * The default message rate limit policy. Applied to every tenant and not
 * tenant-configurable.
 *
 * - `sendWindow`: 3600 seconds (1 hour)
 * - `maxSendsPerRecipient`: 5 per window
 */
export const defaultMessageRateLimitPolicy = Object.freeze({
    sendWindow: 3600,
    maxSendsPerRecipient: 5,
});
